import { Injectable } from '@angular/core';
import { BaseService } from './BaseService';
import { APIServiceConnector } from './APIServiceConnector';
import { AppSettings } from './../Library/AppSettings';
import { ShiftSetupDepartmentData, SimpleResponse } from '../Models/ResponseModels';
import { ShiftSetUpModel, SaveShiftResponse, LoginLogoutRequest, StaffSkill, GetDepartmentDataRequest, DeleteShiftRequest, LoginLogoutWORequest } from '../Models/RequestModels';
import { MasterDataService } from '../Services/MasterDataService';
import { EntityCodes } from '../Models/EnumModels';

@Injectable()
export class ShiftSetUpService extends BaseService {
    URL_WorkOrders: string;
    constructor(public apiService: APIServiceConnector, public masterService: MasterDataService) {
        super();
        this.BaseURL = AppSettings.URL_ComplainService;
        this.URL_WorkOrders = AppSettings.URL_WorkOrders;
    }
    ShiftDetails_Multi(req: any, PropId: number): void {
        if (req == null)
            return;

        if (req.ListShiftStaff) {
            for (let i = 0; i < req.ListShiftStaff.length; i++) {
                let row = req.ListShiftStaff[i];
                row.Description = this.masterService.MasterData_GetMutli(PropId, row.StaffId, EntityCodes.Staff, "");
            }
        }

        if (req.DefaultStaffSkills) {
            for (let i = 0; i < req.DefaultStaffSkills.length; i++) {
                let row = req.DefaultStaffSkills[i];
                row.Description = this.masterService.MasterData_GetMutli(PropId, row.StaffId, EntityCodes.Staff, "");
            }
        }

    }

    //GetStaffName(StaffId: number): string {
    //    return this.masterService.MasterData_GetMutli(this.Model.PropertyId, StaffId, EntityCodes.Staff, "")
    //}
    GetShiftDetails(req: GetDepartmentDataRequest): Promise<SimpleResponse> {

        return this.apiService.postAPI(this.BaseURL, 'ShiftSetup/GetDepartmentData', req).then(data => {
            if (data && !data.HasError) {
                data.Result.SectionLocations = this.GetAllSection(req);
                this.ShiftDetails_Multi(data.Result, req.PropertyId);
            }

            return data;
        })
    }

    GetAllSection(req: any): Array<any> {
        let SectionLocationMapping = [];
        let MappedSections = this.masterService.GetSections(req.PropertyId).filter(obj => obj.DeptId == req.DeptId);
        let AllLocations = this.masterService.GetLocations(req.PropertyId);
        MappedSections.forEach(SectionObj => {
            let MappedLocations = AllLocations.filter(obj => obj.Sections.findIndex(a => a == SectionObj.Id) >= 0);
            MappedLocations.forEach(LocationObj => {
                let SectionLocationMappingObj: any = {};
                SectionLocationMappingObj.SectionId = SectionObj.Id;
                SectionLocationMappingObj.LocationId = LocationObj.Id;
                SectionLocationMappingObj.LocationDescription = LocationObj.Description;
                SectionLocationMapping.push(SectionLocationMappingObj);
            });
        });
        return SectionLocationMapping;
    }

    SaveShiftDetails(req: SaveShiftResponse): Promise<SimpleResponse> {
        return this.apiService.postAPI(this.BaseURL, 'ShiftSetup/SaveShift', req).then(data => {
            return data;
        })
    }

    LoginLogout(req: Array<LoginLogoutRequest>): Promise<SimpleResponse> {
        return this.apiService.postAPI(this.BaseURL, 'ShiftSetup/LoginLogout', req).then(data => {
            return data;
        })
    }

    LoginLogoutWO(req: Array<LoginLogoutWORequest>): Promise<SimpleResponse> {
        return this.apiService.postAPI(this.URL_WorkOrders, 'WorkOrder/WorkOrder_ShiftLogout', req).then(data => {
            return data;
        })
    }

    DeleteShift(req: DeleteShiftRequest): Promise<SimpleResponse> {
        return this.apiService.postAPI(this.BaseURL, 'ShiftSetup/DeleteShift', req).then(data => {
            return data;
        })
    }

    AddDevice(req: any): Promise<SimpleResponse> {
        return this.apiService.postAPI(this.BaseURL, 'ShiftSetup/AddDevices', req).then(data => {
            return data;
        })
    }
}
